import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ACCENT } from "../artistStudio/shared";
import { fanHomeApi, isSignedIn, apiMessage } from "./fanHomeApi";
import { showError } from "../common/errorToast";

// Follow / Following on an artist's public page. Followed artists feed "New from Artists You Follow" on the Fan Home Page.
// Signed-out visitors are sent to log in and brought back here.
export default function FollowButton({ slug, onFollowersChange }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [following, setFollowing] = useState(false);
  const [checked, setChecked] = useState(!isSignedIn());
  const [busy, setBusy] = useState(false);
  const busyRef = useRef(false);

  useEffect(() => {
    if (!isSignedIn()) return undefined;
    let cancelled = false;
    fanHomeApi.following()
      .then((r) => { if (!cancelled) setFollowing((r?.items || []).some((a) => a.slug === slug)); })
      .catch(() => {})
      .finally(() => { if (!cancelled) setChecked(true); });
    return () => { cancelled = true; };
  }, [slug]);

  const toggle = async () => {
    if (!isSignedIn()) { navigate("/login", { state: { from: location } }); return; }
    if (busyRef.current) return;
    busyRef.current = true;
    setBusy(true);
    try {
      const r = following ? await fanHomeApi.unfollow(slug) : await fanHomeApi.follow(slug);
      setFollowing(Boolean(r?.following));
      if (r && r.followers_count !== null && r.followers_count !== undefined && onFollowersChange) onFollowersChange(r.followers_count);
    } catch (e) {
      showError(apiMessage(e, "We couldn't update this. Please try again."));
    } finally {
      busyRef.current = false;
      setBusy(false);
    }
  };

  return (
    <div>
      <button
        type="button" onClick={toggle} disabled={busy || !checked} aria-pressed={following}
        className={`inline-flex items-center justify-center rounded-full font-semibold leading-normal px-6 py-2 text-sm border-2 disabled:opacity-60 ${following ? "bg-white" : "text-white"}`}
        style={following ? { borderColor: ACCENT, color: ACCENT } : { backgroundColor: ACCENT, borderColor: ACCENT }}
      >
        {following ? "Following" : "Follow"}
      </button>
    </div>
  );
}
